<!-- <app-sites-mat-table-maint [companyId]="site.companyId"></app-sites-mat-table-maint> -->

<table style=" border-collapse: collapse;width:100%; background: transparent; border: 0px; padding: 0px; margin: 0px;">
 <tr>
     <td>
        <img style="height:100%; width: 50%;" [src]="'./assets/images/admir_icon.png'" />
     </td>
 </tr>
 
    <tr>
        <td style="width:70%; vertical-align: top;">
            <table style="width:100%; background: transparent; border-collapse: collapse; padding: 0px; margin: 0px;">
                <tr>
                    <td style="width:100%; height: auto;">
                        <h1><b><span >{{site.siteName}}</span></b></h1>
                    </td>
                </tr>
            </table>
        </td>
    </tr>

    <tr>
        <td style="width:70%; vertical-align: top;">
            <table style="width:100%; background: transparent; border-collapse: collapse; padding: 0px; margin: 0px;">
                <tr>
                    <td style="width:100%; height: auto;">
                    <h2><b><span >{{site.address}}, {{site.city}} {{site.region}} {{site.postalCode}}</span></b></h2>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</table>